import { createAction } from 'redux-actions';

export const CHANGE_PRODUCT_TABLE_PAGE = 'CHANGE_PRODUCT_TABLE_PAGE';

export default createAction(CHANGE_PRODUCT_TABLE_PAGE);
